module.exports = __webpack_public_path__ + "static/media/HCMM201.8e6a5dd0.jpg";